export const COMMISSION = {
  COMMISSIONS: 'COMMISSIONS',
  COMMISSION_AGENT_RATES: 'COMMISSION_AGENT_RATES',
  COMMISSION_IMPORT: 'COMMISSIONS_IMPORT',
  COMMISSION_SCHEMA: 'COMMISSION_SCHEMA',
  COMMISSION_SCHEMAS: 'COMMISSION_SCHEMAS',
  COMMISSION_IMPORT_RECORDS: 'COMMISSIONS_IMPORT_RECORDS',
};
